import ReminderSelection from './ReminderSelection';
import EventDurationSelection from './EventDurationSelection';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Stateless functional component to render event duration and reminder dropdowns.
 */
export default observer(function EventFull() {
    return (
        <div>
            <OptionDescription>{strings.options_event_description}</OptionDescription>
            {isFeatureEnabled('cal-event-duration-setting') && <EventDurationSelection />}
            <ReminderSelection />
        </div>
    );
});
